import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button
} from '@chakra-ui/react';
import React from 'react';

export function UpdateEntrega({ onClick, isLoading }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  async function handleUpdateEntrega() {
    await onClick();

    onClose();
  }

  return (
    <>
      <Button size="sm" colorScheme="green" onClick={onOpen}>
        Confirmar Entrega
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Você está prestes a confirmar a entrega do pedido.
            </AlertDialogHeader>

            <AlertDialogBody>Tem certeza que deseja confirmar a entrega do pedido?</AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="red" ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                onClick={handleUpdateEntrega}
                ml={3}
                colorScheme="green"
                isLoading={isLoading}
                loadingText="Confirmando...">
                Confirmar Entrega
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
